import styled from 'styled-components';
import tokens from '@fcc/tokens/dist/tokens.json';
import { Button, P, Link, Flex } from '@fcc/ui';

interface CustomButtonProps {
    loading: boolean;
    backgroundColor: string;
    textColor: string;
}

interface DefaultAmountButtonProps {
    isActive: boolean;
    color: string;
}

interface WidgetWrapperProps {
    width?: string;
}

export const WidgetWrapper = styled.div<WidgetWrapperProps>`
    max-width: 728px;
    width: ${(props) => props.width || '100%'};
    border-radius: ${tokens.border.radius.xl}px;
    background-color: ${tokens.color.primary.seattle.c05};
    outline: 1px solid ${tokens.color.primary.seattle.c05};
    outline-offset: -1px;
    margin: 0 auto;
    @font-face {
        font-family: 'ALS Hauss';
        src: url('https://www.raiffeisen.ru/common/new/images/fonts/ALS_Hauss-Medium.woff') format('woff');
        src: url('https://www.raiffeisen.ru/common/new/images/fonts/ALS_Hauss-Bold.woff') format('woff');
        src: url('https://www.raiffeisen.ru/common/new/images/fonts/ALS_Hauss-Regular.woff') format('woff');
    }
`;

export const WidgetHeader = styled(Flex)`
    padding: 14px;
`;

export const WidgetBody = styled.div`
    border-radius: ${tokens.border.radius.xl}px;
    background-color: ${tokens.color.primary.brand.white};
    padding: 14px;
`;

export const CustomButton = styled(Button)<CustomButtonProps>`
    background: ${({ loading, backgroundColor }) =>
        loading ? `${tokens.color.primary.seattle.c10}` : `#${backgroundColor}`};
    width: 100%;
    margin-bottom: ${tokens.layout.size.s2}px;
    & p {
        color: ${({ textColor }) => `#${textColor}`};
    }
    &:hover {
        background: ${({ backgroundColor, loading }) =>
            loading
                ? '#F0ECEC'
                : `linear-gradient(0deg, rgba(43, 45, 51, 0.2) 0%, rgba(43, 45, 51, 0.2) 100%), #${backgroundColor};`};
    }
`;

export const CustomP = styled(P)`
    font-size: 10px;
`;

export const NspkLogoBox = styled.div`
    display: inline-block;
    width: ${tokens.layout.size.s5}px;
    height: ${tokens.layout.size.s5}px;

    svg {
        max-width: ${tokens.layout.size.s5}px;
        max-height: ${tokens.layout.size.s5}px;
    }
`;

export const CustomLink = styled(Link)`
    font-size: 10px;
    text-underline-offset: 0px;
    color: ${tokens.color.primary.seattle.c100};
    & span {
        text-decoration-color: ${tokens.color.primary.seattle.c100};
    }
`;

export const ClientLogo = styled.img`
    max-width: 92px;
    border-radius: ${tokens.border.radius.m}px;
`;

export const DefaultAmountButton = styled(Button)<DefaultAmountButtonProps>`
    background: ${({ isActive, color }) => (isActive ? `#${color}33` : `${tokens.color.primary.seattle.c05}`)};
    &:hover {
        background: ${({ isActive, color }) => (isActive ? `#${color}33` : `${tokens.color.primary.seattle.c05}`)};
    }
`;

export const ClickableP = styled(P)`
    cursor: pointer;
`;
